import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-location-icon',
  templateUrl: './location-icon.component.html',
  styleUrls: ['./location-icon.component.scss']
})
export class LocationIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
